import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail } from "lucide-react";
import { useContent } from "@/lib/useContent";

export default function Footer() {
    const { settings } = useContent();
    const email = settings.contact_email;

    return (
        <footer
            data-testid="site-footer"
            className="bg-ink text-paper border-t-2 border-ink mt-24"
        >
            <div className="h-2 w-full bg-gradient-to-r from-[#E82574] via-[#F39E60] to-[#E82574]" />
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-6">
                        <p className="font-display font-black text-4xl sm:text-5xl leading-none">
                            BOMGAY<span className="text-pink">.in</span>
                        </p>
                        <p className="mt-5 text-paper/70 max-w-md text-sm leading-relaxed">
                            A queer cultural podcast from Bombay, documenting the stories,
                            histories and lived experiences that shape LGBTQIA+ life across
                            India, South Asia and beyond. One story at a time.
                        </p>
                        <div className="mt-6 flex items-center gap-4">
                            <a
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-instagram-link"
                                aria-label="Instagram"
                                className="p-2.5 border-2 border-paper/30 text-paper transition-colors duration-200 hover:border-pink hover:text-pink"
                            >
                                <Instagram className="w-4 h-4" />
                            </a>
                            <a
                                href="https://www.youtube.com/@Bomgayy"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-youtube-link"
                                aria-label="YouTube"
                                className="p-2.5 border-2 border-paper/30 text-paper transition-colors duration-200 hover:border-pink hover:text-pink"
                            >
                                <Youtube className="w-4 h-4" />
                            </a>
                            <a
                                href={`mailto:${email}`}
                                data-testid="footer-email-link"
                                aria-label="Email"
                                className="p-2.5 border-2 border-paper/30 text-paper transition-colors duration-200 hover:border-pink hover:text-pink"
                            >
                                <Mail className="w-4 h-4" />
                            </a>
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-mustard">
                            Explore
                        </p>
                        <ul className="mt-4 space-y-3 font-sub font-bold">
                            <li><Link data-testid="footer-nav-episodes" to="/episodes" className="hover:text-pink transition-colors duration-200">Episodes</Link></li>
                            <li><Link data-testid="footer-nav-voices" to="/voices" className="hover:text-pink transition-colors duration-200">Voices</Link></li>
                            <li><Link data-testid="footer-nav-about" to="/about" className="hover:text-pink transition-colors duration-200">About</Link></li>
                            <li><Link data-testid="footer-nav-press" to="/press" className="hover:text-pink transition-colors duration-200">Press Kit</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-3">
                        <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-mustard">
                            Say hello
                        </p>
                        <a
                            href={`mailto:${email}`}
                            data-testid="footer-contact-email"
                            className="mt-4 inline-block font-sub font-bold text-lg hover:text-pink transition-colors duration-200 break-all"
                        >
                            {email}
                        </a>
                        <p className="mt-3 text-sm text-paper/60">
                            Hosted by <span className="text-paper">Sagar Malkar</span>
                            <br />
                            Bombay, India
                        </p>
                    </div>
                </div>
                <div className="mt-14 pt-6 border-t border-paper/15 flex flex-col sm:flex-row justify-between gap-3 text-xs font-mono-brand uppercase tracking-[0.18em] text-paper/50">
                    <span data-testid="footer-copyright">© 2026 BOMGAY.in | A queer podcast</span>
                    <span className="flex items-center gap-5">
                        <span>Rooted in Bombay. Never confined by it.</span>
                        <Link data-testid="footer-host-login-link" to="/login" className="hover:text-pink transition-colors duration-200">Host login</Link>
                    </span>
                </div>
            </div>
        </footer>
    );
}
